// extracted by mini-css-extract-plugin
export default {"reasonsWrapper":"_8iLA4eAQE+GuwmZCwqf20w==","reason":"_60FiDuFzlmEQTD8ipwv89Q=="};